import { SvgIcon } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import { element, number, string } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';
import { Link, useLocation } from 'react-router';

const getStyles = (theme, index) => ({
  itemRoot: {
    borderRadius: '5px',
    // The divider is the label's top border. Button padding would sit outside
    // that line and leave the icon and label high in the gap.
    paddingTop: 0,
    paddingBottom: 0,
    '& + & .MuiListItemText-root': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    '&:hover .MuiListItemText-root': {
      borderColor: 'transparent !important',
    },
    '&:hover + & .MuiListItemText-root': {
      borderColor: 'transparent !important',
    },
  },
  itemSelected: {
    '& .MuiListItemText-root': {
      borderColor: 'transparent !important',
    },
    '& .MuiListItemText-primary': {
      fontWeight: 600,
    },
    '& + & .MuiListItemText-root': {
      borderColor: 'transparent !important',
    },
  },
  itemTextRoot: {
    // 50px content plus the 8px button padding this used to sit inside.
    minHeight: 66,
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    borderBottom: 0,
  },
  icon: {
    fontSize: 32,
    color: theme.palette.icons[index],
  },
});

const SettingsItem = ({ icon, index, name }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme, index), [theme, index]);
  const location = useLocation();
  const isSelected = location.pathname.endsWith(`/settings/${name}`);

  return (
    <ListItemButton
      sx={[styles.itemRoot, isSelected && styles.itemSelected]}
      component={Link}
      to={`/home/settings/${name}`}
      key={name}
      selected={isSelected}
    >
      <ListItemIcon>
        <SvgIcon sx={styles.icon}>{icon}</SvgIcon>
      </ListItemIcon>
      <ListItemText sx={styles.itemTextRoot} primary={I18n.t(`SettingsMenu.${name}`)} />
    </ListItemButton>
  );
};

SettingsItem.propTypes = {
  name: string.isRequired,
  icon: element.isRequired,
  index: number.isRequired,
};

export default SettingsItem;
